import { Link } from "react-router-dom";
import { ArrowUpRight, Check, CalendarClock, Users, KeyRound, Sparkles } from "lucide-react";
import { PageHero, CTASection } from "../components/sections";
import { Reveal, Eyebrow } from "../components/common";
import { IMAGES, COMPANY } from "../data/site";
import Seo from "../components/Seo";
import { SEO } from "../data/seo";

const cleaneoFeatures = [
  { icon: <CalendarClock size={18} />, t: "Planning & interventions" },
  { icon: <Users size={18} />, t: "Suivi des équipes & logements" },
  { icon: <KeyRound size={18} />, t: "Centralisation des informations" },
  { icon: <Sparkles size={18} />, t: "Organisation rapide & professionnelle" },
];

const livretFeatures = [
  "Livret d'accueil digital intégré",
  "Instructions & infos utiles du logement",
  "Recommandations locales",
  "Accès simple pour les voyageurs",
];

export default function Applications() {
  return (
    <div data-testid="applications-page">
      <Seo {...SEO.applications} />
      <PageHero
        eyebrow="Application"
        title="<em style='color:var(--gold-2)'>Cleanéo</em>"
        sub="L'application tout-en-un pour gérer vos locations saisonnières : gestion des équipes de ménage et livret d'accueil digital pour vos voyageurs."
        image={IMAGES.laptop}
      />

      {/* CLEANEO */}
      <section className="section">
        <div className="container-x grid lg:grid-cols-2 gap-14 items-center">
          <div>
            <div className="flex items-center gap-3">
              <Eyebrow>Pro</Eyebrow>
              <span className="text-xs px-2 py-1" style={{ background: "var(--gold)", color: "#fff", borderRadius: 4 }}>NOUVEAU</span>
            </div>
            <Reveal>
              <h2 className="display-title mt-3 text-5xl">Cleanéo</h2>
            </Reveal>
            <Reveal delay={80}>
              <p className="mt-4 leading-relaxed" style={{ color: "var(--muted)" }}>
                L'application de gestion pensée pour les entreprises de ménage et de
                conciergerie : planification, suivi des interventions et centralisation
                des informations en un seul endroit.
              </p>
            </Reveal>
            <ul className="mt-7 space-y-3">
              {cleaneoFeatures.map((f) => (
                <li key={f.t} className="flex items-center gap-3">
                  <span style={{ color: "var(--gold)" }}>{f.icon}</span> {f.t}
                </li>
              ))}
            </ul>
            <div className="flex flex-wrap gap-3 mt-8">
              <a href={COMPANY.cleaneo} target="_blank" rel="noreferrer" className="btn btn-primary">
                Ouvrir Cleanéo <ArrowUpRight size={16} />
              </a>
              <Link to="/contact" className="btn btn-outline-dark">Plus d'informations</Link>
            </div>
          </div>
          <Reveal delay={120}>
            <img src={IMAGES.laptop} alt="Cleanéo" className="w-full object-cover" style={{ height: 440 }} />
          </Reveal>
        </div>
      </section>

      {/* LIVRET D'ACCUEIL INTÉGRÉ */}
      <section className="section" style={{ background: "var(--ink)" }}>
        <div className="container-x grid lg:grid-cols-2 gap-14 items-center">
          <Reveal>
            <img src={IMAGES.bedroom} alt="Livret d'accueil digital" className="w-full object-cover" style={{ height: 440 }} />
          </Reveal>
          <div>
            <Eyebrow light>Inclus dans Cleanéo</Eyebrow>
            <Reveal>
              <h2 className="display-title text-white mt-3 text-5xl">Le livret d'accueil digital</h2>
            </Reveal>
            <Reveal delay={80}>
              <p className="mt-4 leading-relaxed" style={{ color: "rgba(255,255,255,0.7)" }}>
                Le livret d'accueil digital (anciennement HostBook) est désormais
                intégré directement à Cleanéo. La gestion opérationnelle et
                l'expérience voyageur sont réunies dans un seul environnement,
                plus complet et plus fluide.
              </p>
            </Reveal>
            <ul className="mt-7 space-y-3">
              {livretFeatures.map((f) => (
                <li key={f} className="flex items-center gap-3 text-white">
                  <Check size={16} style={{ color: "var(--gold)" }} /> {f}
                </li>
              ))}
            </ul>
            <a href={COMPANY.cleaneo} target="_blank" rel="noreferrer" className="btn btn-primary mt-8">
              Ouvrir Cleanéo <ArrowUpRight size={16} />
            </a>
          </div>
        </div>
      </section>

      <section className="section">
        <div className="container-x text-center max-w-2xl mx-auto">
          <Reveal><Eyebrow>On vous guide en 2 minutes</Eyebrow></Reveal>
          <Reveal delay={80}>
            <h2 className="display-title mt-4 text-4xl">Hôte, conciergerie ou entreprise de ménage ?</h2>
          </Reveal>
          <Reveal delay={140}>
            <p className="mt-4" style={{ color: "var(--muted)" }}>
              Parlez-nous de votre profil et de vos besoins, on vous oriente vers la bonne solution.
            </p>
          </Reveal>
          <Reveal delay={200}>
            <Link to="/contact" className="btn btn-primary mt-8">Nous contacter</Link>
          </Reveal>
        </div>
      </section>

      <CTASection />
    </div>
  );
}
